import { UserType } from './user'

export const USER_TYPE_MAP: Record<UserType, string> = {
  [UserType.GUEST]: '게스트',
  [UserType.HOST]: '호스트',
}
